export default __webpack_public_path__ + "static/media/Drop.e6dc171a.svg";